module.exports = __webpack_public_path__ + "static/img/audio_white.9224c06e.svg";